<template>
  <div class="tab-nav-container">
    <div class="top-nav-bar">
      <div class="back-btn" @click="onGoback">
        <i class="cubeic-back"></i>
      </div>
      <div class="top-container">
        <div class="title-info-container">
          {{titleInfo}}
        </div>
      </div>
      <div :class="['right-btn', isLoading?'loading-btn':'']" @click="onRightBtn" v-if="rightText">
        <div class="right-text">{{rightText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TopNavbar",
    props: {
      title: "",
      rightText: "",
      isLoading: {},
    },
    components: {},
    data() {
      return {
        titleInfo: "",
      }
    },
    mounted() {
      this.titleInfo = this.title
    },
    methods: {
      onGoback() {
        this.$router.go(-1)
      },
      onRightBtn() {
        this.$emit("clickRight")
      }
    },
    watch: {
      title() {
        this.titleInfo = this.title
      }
    }

  }
</script>

<style lang="scss" scoped>
  .tab-nav-container {
    position: fixed;
    width: 100%;
    z-index: 1000;
    left: 0;
    top: 0;

    .top-nav-bar {
      position: relative;
      background: white;
      top: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #f2f2f2;
      min-height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;

      .top-container {
        overflow: hidden;
        position: relative;
        max-width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0;
        margin: 0 auto;

        .title-info-container {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .back-btn {
        color: #fc9153;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        height: 44px;
        padding: 0 15px;
        position: absolute;
        left: 0;
      }

      .right-btn {
        position: absolute;
        color: #fc9153;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        right: 0;
        height: 44px;
        padding: 0 15px;
      }

      .loading-btn {
        color: grey;
      }
    }
  }

</style>
